<script setup lang="ts">
import { DropDown, ButtonIcon } from "@frontiers-vue3/public-pages";
import type { IChartMode } from "../../common/types";
import { type IRTImpactControls } from "./IRTImpactControls";
import { ChartPeriodEnum } from "~/enums";
const props = defineProps<IRTImpactControls>();

const emit = defineEmits<{
  (e: "chartModeUpdated", chartMode: IChartMode): void;
  (e: "chartTimePeriodUpdated", timePeriod: ChartPeriodEnum): void;
}>();

const chartDateSummaryList = ref([
  { id: ChartPeriodEnum.beginning, name: ChartPeriodEnum.beginning },
  { id: ChartPeriodEnum.lastMonth, name: ChartPeriodEnum.lastMonth },
  { id: ChartPeriodEnum.lastYear, name: ChartPeriodEnum.lastYear }
]);

const isActiveItem = (item: IChartMode): boolean => {
  return props.chartMode === item;
};
</script>
<template>
  <div class="RTImpactControls">
    <DropDown
      class="RTImpactControls__timePeriod"
      :selected-value="props.chartPeriod"
      :items="chartDateSummaryList"
      data-text="name"
      title="Time period"
      @selected-item="
        (t) => emit('chartTimePeriodUpdated', t.name as ChartPeriodEnum)
      " />

    <ul :class="`RTImpactControls__list ${chartMode}`">
      <li :class="{ active: isActiveItem('spline') }">
        <ButtonIcon
          icon="chartBar"
          @click="emit('chartModeUpdated', 'spline')" />
      </li>
      <li :class="{ active: isActiveItem('column') }">
        <ButtonIcon
          icon="graphLine"
          @click="emit('chartModeUpdated', 'column')" />
      </li>
      <li :class="{ active: isActiveItem('map') }">
        <ButtonIcon icon="location" @click="emit('chartModeUpdated', 'map')" />
      </li>
    </ul>
  </div>
</template>
<style lang="scss">
.RTImpactControls {
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media #{$break-xs} {
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
  }

  &__timePeriod {
    width: 220px;

    @media #{$break-xs} {
      width: 230px;
    }

    .DropDown {
      margin-bottom: 0;

      .DropDown > * {
        position: relative;
      }
    }
  }

  &__list {
    display: flex;
    border: 1px solid $grey60;
    border-radius: 96px;
    height: 46px;
    margin-left: 0;
    width: 168px;

    @media #{$break-xs} {
      width: 228px;
    }

    li {
      width: 160px;
      display: flex;
      justify-content: center;
      @include f-14-300;

      button {
        color: inherit;

        svg {
          fill: $grey70;
        }
      }
    }

    .active {
      color: $white;
      background-color: $grey80;
      border-radius: 40px;

      svg {
        fill: $white;
      }
    }
  }
}
</style>
